var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack161({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 2.68,
    rx: 1.93,
    ry: 1.94
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 2.43,
    cy: 6.74,
    rx: 1.93,
    ry: 1.94
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 4.56,
    cy: 13.32,
    rx: 1.93,
    ry: 1.94
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 11.44,
    cy: 13.32,
    rx: 1.93,
    ry: 1.94
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 13.57,
    cy: 6.74,
    rx: 1.93,
    ry: 1.94
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 8.52,
    rx: 1.71,
    ry: 1.72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,6.8a2,2,0,0,1,.49.08V4.55a1.75,1.75,0,0,1-1,0V6.88A2,2,0,0,1,8,6.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.71,8.52h0L12,7.79a1.71,1.71,0,0,1-.22-.45,2,2,0,0,1-.09-.48l-2.21.72A1.76,1.76,0,0,1,9.71,8.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.54,10.14l1.41,2a1.93,1.93,0,0,1,.35-.35,2.06,2.06,0,0,1,.44-.23L9.34,9.58A1.74,1.74,0,0,1,8.54,10.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.57,7.58,4.36,6.85a2,2,0,0,1-.09.49,1.88,1.88,0,0,1-.22.45l2.24.73A1.76,1.76,0,0,1,6.57,7.58Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.66,9.58l-1.4,1.94a1.78,1.78,0,0,1,.43.23,2,2,0,0,1,.36.35l1.41-2A1.74,1.74,0,0,1,6.66,9.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack161);
export default __webpack_public_path__ + "static/media/Symbolpack_1_61.158a667aad7da031c7eb3ce57ae5c8e3.svg";
export { ForwardRef as ReactComponent };